import React from 'react';
import Button from './Button';

/**
 * Pagination unique des listes paginées par l'API ({ page, totalPages, totalElements }).
 * `onSize` facultatif : affiche le choix du nombre de lignes par page.
 */
export default function Pager({ page, totalPages, totalElements, size, onPage, onSize, sizes = [20, 50, 100, 200] }) {
  const last = Math.max(totalPages - 1, 0);
  return (
    <div style={styles.bar}>
      <span style={styles.info}>{totalElements} élément(s)</span>
      <div style={styles.nav}>
        <Button size="sm" onClick={() => onPage(0)} disabled={page === 0} title="Première page">«</Button>
        <Button size="sm" onClick={() => onPage(page - 1)} disabled={page === 0}>‹ Précédent</Button>
        <span style={styles.info}>Page {totalPages === 0 ? 0 : page + 1} / {totalPages}</span>
        <Button size="sm" onClick={() => onPage(page + 1)} disabled={page >= last}>Suivant ›</Button>
        <Button size="sm" onClick={() => onPage(last)} disabled={page >= last} title="Dernière page">»</Button>
      </div>
      {onSize ? (
        <label style={styles.info}>
          Par page{' '}
          <select value={size} onChange={e => onSize(Number(e.target.value))} style={styles.select}>
            {sizes.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </label>
      ) : <span />}
    </div>
  );
}

const styles = {
  bar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap', padding: '0.75rem 0 0' },
  nav: { display: 'flex', gap: '0.4rem', alignItems: 'center' },
  info: { color: '#6b7280', fontSize: '0.85rem' },
  select: { marginLeft: '0.35rem', background: '#f5f5f5', border: '1px solid #cdcdcd', borderRadius: '6px', padding: '0.25rem 0.4rem', color: '#444444' },
};
